var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12670",
    "data-name": "Group 12670",
    transform: "translate(-415 -240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11636",
    "data-name": "Group 11636",
    transform: "translate(415 240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    "data-name": "Group 2192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    fill: "#fff",
    stroke: "#237697",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1",
    "data-name": "Path 1",
    transform: "translate(21.402 21.402)",
    fill: "#247395"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.80490112304688 82.60980987548828 C 37.42995452880859 82.60980987548828 32.21736907958984 81.55779266357422 27.31195449829102 79.48297119140625 C 22.5723819732666 77.47830200195312 18.3151683807373 74.60781097412109 14.65859413146973 70.95121765136719 C 11.00200748443604 67.29463195800781 8.131514549255371 63.03742218017578 6.126847743988037 58.29784774780273 C 4.052021026611328 53.39243316650391 3.00000786781311 48.17984771728516 3.00000786781311 42.80490112304688 C 3.00000786781311 37.42995452880859 4.052021026611328 32.21736907958984 6.126847743988037 27.31195449829102 C 8.131514549255371 22.5723819732666 11.00200748443604 18.3151683807373 14.65859413146973 14.65859413146973 C 18.3151683807373 11.00200748443604 22.5723819732666 8.131514549255371 27.31195449829102 6.126847743988037 C 32.21736907958984 4.052021026611328 37.42995452880859 3.00000786781311 42.80490112304688 3.00000786781311 C 48.17984771728516 3.00000786781311 53.39243316650391 4.052021026611328 58.29784774780273 6.126847743988037 C 63.03742218017578 8.131514549255371 67.29463195800781 11.00200748443604 70.95121765136719 14.65859413146973 C 74.60781097412109 18.3151683807373 77.47830200195312 22.5723819732666 79.48297119140625 27.31195449829102 C 81.55779266357422 32.21736907958984 82.60980987548828 37.42995452880859 82.60980987548828 42.80490112304688 C 82.60980987548828 48.17984771728516 81.55779266357422 53.39243316650391 79.48297119140625 58.29784774780273 C 77.47830200195312 63.03742218017578 74.60781097412109 67.29463195800781 70.95121765136719 70.95121765136719 C 67.29463195800781 74.60781097412109 63.03742218017578 77.47830200195312 58.29784774780273 79.48297119140625 C 53.39243316650391 81.55779266357422 48.17984771728516 82.60980987548828 42.80490112304688 82.60980987548828 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 42.80490112304688 6 C 22.51061630249023 6 6 22.51061630249023 6 42.80490112304688 C 6 63.09918212890625 22.51061630249023 79.60980224609375 42.80490112304688 79.60980224609375 C 63.09918212890625 79.60980224609375 79.60980224609375 63.09918212890625 79.60980224609375 42.80490112304688 C 79.60980224609375 22.51061630249023 63.09918212890625 6 42.80490112304688 6 M 42.80490112304688 0 C 66.44540405273438 0 85.60980224609375 19.16439819335938 85.60980224609375 42.80490112304688 C 85.60980224609375 66.44540405273438 66.44540405273438 85.60980224609375 42.80490112304688 85.60980224609375 C 19.16439819335938 85.60980224609375 0 66.44540405273438 0 42.80490112304688 C 0 19.16439819335938 19.16439819335938 0 42.80490112304688 0 Z",
    stroke: "none",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButton);
export default __webpack_public_path__ + "static/media/RadioButton.e93190cb16ee48d267d50c0d8488b108.svg";
export { ForwardRef as ReactComponent };